import React from 'react'
import NFLTemplate from 'src/components/page/nfl'
import { teamIds } from 'src/constants/personalizationIds'

export default (props) => {
  return (
    <NFLTemplate
      {...props}
      team="Dallas Cowboys"
      teamShort="Cowboys"
      teamId={teamIds['Dallas Cowboys']}
    />
  )
}
